// @flow
import {
  Button,
  CircularProgress,
  Fab,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  RadioGroup,
  Radio,
  TextField,
  Typography
 } from '@material-ui/core';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { Link, Route, withRouter } from 'react-router-dom';
import Loading from '../../components/Loading';
import OrganizationsSearchResults from '../../components/OrganizationSearchResults';
import {
  fetchWithToken,
  getAvaBackendEndpoint,
  getSaasBackendEndpoint,
  getSubscriptionBackendEndpoint
} from '../../utils/http';
import * as segment from '../../utils/segment';

import Work from '../../../assets/images/work.svg';
import School from '../../../assets/images/school.svg';
import Event from '../../../assets/images/event.svg';
import Video from '../../../assets/images/video.svg';
import DeafEmoji from '../../../assets/images/deafEmoji.png';
import HohEmoji from '../../../assets/images/hohEmoji.png';
import EarEmoji from '../../../assets/images/earEmoji.png';
import SomeoneSpeaking from '../../../assets/images/someoneSpeaking.png';
import addOrg from '../../../assets/icons/add_org.svg';
import hrOrg from '../../../assets/icons/hr.svg';
import eduOrg from '../../../assets/icons/edu.svg';
import eventOrg from '../../../assets/icons/event.svg';


const styles = theme => ({
  outerWrap: {
    margin: '0 auto',
    maxWidth: 600,
    width: '100%',
  },
  title: {
    fontWeight: 700,
  },
  orgTypeOptionsWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: theme.spacing(4),
    width: '100%',
  },
  orgTypeButton: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      textDecoration: 'none',
    },
    '&:focus': {
      outline: 'none'
    },
    [theme.breakpoints.down('sm')]: {
      '& h6': {
        fontSize: '1rem',
      },
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
      marginBottom: theme.spacing(2),
      width: `calc(50% - ${theme.spacing(1)}px)`,
    },
    background: 'transparent',
    border: `2px solid ${theme.palette.border}`,
    borderRadius: 12,
    flexGrow: 0,
    marginBottom: theme.spacing(4),
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
    WebkitAppearance: 'none',
    width: `calc(50% - ${theme.spacing(2)}px)`,
  },
  orgTypeIllustration: {
    width: '100%',
  },
  orgInfoOptionsWrap: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 auto',
    marginTop: theme.spacing(2),
    maxWidth: 420,
    width: '100%',
  },
  formControl: {
    marginBottom: theme.spacing(2),
  },
  formLabel: {
    fontSize: '1em',
    marginBottom: 8,
  },
  helperText: {
    marginLeft: 14,
  },
  checkboxHelperText: {
    lineHeight: 3,
  },
  orgTypeLabel: {
    textTransform: 'capitalize',
  },
  noDecorationLink: {
    '&:hover': {
      textDecoration: 'none',
    }
  },
  button: {
    boxShadow: 'none',
    fontWeight: 700,
    marginTop: theme.spacing(2),
  },
  centerText: {
    textAlign: 'center',
  },
  fab: {
    backgroundColor: 'white',
    textTransform: 'none',
    fontSize: 18,
    color: '#102867',
    fontWeight: 400,
    height: 94,
    textAlign: 'left',
    display: 'flex',
    marginBottom: theme.spacing(4),
  },
  fabBold: {
    fontWeight: 800,
  },
  fabContainer: {
    display: 'flex',
    maxWidth: 230,
    margin: 'auto',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  fabContainerVoicingProfile: {
    display: 'flex',
    maxWidth: 300,
    margin: 'auto',
  },
  fabMargin: {
    marginRight: 17,
    marginLeft: 17,
    height: 55,
  },
  orgaSearchProgress: {
    position: 'absolute',
    width: 20,
    height: 20,
    right: 17,
    top: 17,
    color: theme.palette.ava.blue,
  },
  searchFieldWithPadding: {
    paddingLeft: 30,
  },
  searchResultTypePicto: {
    position: "absolute",
    left: 9,
    top: 18,
    width: 25,
  },
});

type Props = {
  classes: Object,
  firebaseUser: Object,
  i18n: Object,
  history: Object,
  location: Object,
  t: Function,
};

type State = {
  userName: string,
  userNameRequiredError: boolean,
  userNameResError: boolean,
  orgType: string,
  isAdmin?: string,
  isAdminRequiredError: boolean,
  orgId?: string,
  inputOrgName?: string,
  orgName?: string,
  orgNameRequiredError: boolean,
  loading: boolean,
  resError?: string,
  hearingProfile?: string,
  organizationsSearchResults: Object,
  showOrgSearchResults: boolean,
  currentlySearchingOrganizations: boolean,
};

class ScribeLoginProfiling extends React.Component<Props, State> {
  findOrganizationsByOrgName = null;
  
  currentOrganizationSearch = null;

  constructor(props: Props) {
    super(props);
    this.state = {
      userName: '',
      orgType: 'hr',
      isAdmin: '',
      userNameRequiredError: false,
      userNameResError: false,
      isAdminRequiredError: false,
      orgNameRequiredError: false,
      orgId: undefined,
      inputOrgName: '',
      loading: false,
      hearingProfile: undefined,
      organizationsSearchResults: null,
      showOrgSearchResults: false,
      currentlySearchingOrganizations: false,
    };
    this.findOrganizationsByOrgName = _.debounce(this.fetchOrganizationsByOrgName, 700);
  }

  setUserName = (e) => {
    this.setState({
      userName: e.target.value,
      userNameRequiredError: false,
    })
  }

  disabledUsername() {
    const { userName } = this.state
    return !userName;
  }

  submitUserName = () => {
    const { userName } = this.state
    if (userName) {
      const { firebaseUser } = this.props
      const endpoint = getAvaBackendEndpoint();
      const avaId = window.localStorage.getItem("avaId");
      this.setState({ loading: true })
      fetchWithToken(
        `${endpoint}/api/v1.1/users/${avaId}?firebaseAuthUID=${firebaseUser.uid}`,
        {
          method: 'PATCH',
          body: JSON.stringify({
            userName
          })
        }
      ).then(res => res.json())
      .then(res => {
        if (res.ok) {
          segment.track('Updated Name', { Name: userName });
          segment.identify({ Name: userName });
          const { location, history } = this.props
          const locationArray = location.pathname.split('/')
          this.setState({
            loading: false
          })
          if (locationArray[locationArray.length - 1] === 'user-name-subscribed') {
            if (location.pathname.split('/')[1] === 'web') {
              history.push("/web/?startConvo=true")
            } else if (location.pathname.split('/')[1] === 'scribe') {
              history.push("/scribe/")
            }
          } else if (locationArray[1] === 'web') {
            history.push("/web/login/profile/hearing-profile")
          } else if (locationArray[1] === 'scribe') {
            history.push("/scribe/login/profile/hearing-profile")
          }
        } else {
          this.setState({
            loading: false,
            userNameResError: true,
          })
        }
      })
    } else {
      this.setState({
        userNameRequiredError: true,
      })
    }
  }

  patchProfile = (profile: number) => {
    const { firebaseUser } = this.props;
    const endpoint = getAvaBackendEndpoint();
    const avaId = window.localStorage.getItem('avaId');
    fetchWithToken(
      `${endpoint}/api/v1.1/users/${avaId}?firebaseAuthUID=${firebaseUser.uid}`,
      {
        method: 'PATCH',
        body: JSON.stringify({
          hearingProfile: profile,
        }),
      }
    );
  };

  setHearingProfile = hearingProfile => {
    segment.track('Hearing Profiled', {
      'Hearing Profile': hearingProfile,
    });
    segment.identify({
      'Hearing Profile': hearingProfile,
    });
    this.setState({ hearingProfile });
    const { location, history } = this.props;
    const locationArray = location.pathname.split('/');
    if (hearingProfile === 'hearing') {
      history.push(`/${locationArray[1]}/login/profile/org-type`);
      this.patchProfile(2);
    } else {
      history.push(`/${locationArray[1]}/login/profile/voicing-profile`);
    }
  };

  setVoicingProfile = voicingProfile => {
    segment.track('Voice Checked', {
      Voice: voicingProfile,
    });
    segment.identify({
      Voice: voicingProfile,
    });
    const { hearingProfile } = this.state;
    const { location, history } = this.props;
    const locationArray = location.pathname.split('/');
    history.push(`/${locationArray[1]}/login/profile/org-type`);
    if (hearingProfile === 'hard-of-hearing') {
      if (voicingProfile === 'not voicing') {
        this.patchProfile(3);
      } else {
        this.patchProfile(1);
      }
    } else if (hearingProfile === 'deaf') {
      if (voicingProfile === 'not voicing') {
        this.patchProfile(4);
      } else {
        this.patchProfile(0);
      }
    }
  };

  setOrgType = (orgType) => {
    if (orgType === 'video') {
      this.setState({
        loading: true
      });

      segment.track('Role Profiled', { 'Role': 'user' });
      segment.identify({ 'Role': 'user' });

      const parseAccount = window.localStorage.getItem("parseId")

      const data = {
        parseAccount,
        "plateform": "Webapp",
        "subtype": "null",
        "type": "Free",
      }

      const body = Object.keys(data).reduce((acc, cur) => `${acc}&${cur}=${data[cur]}`, '');

      const subscriptionEndpoint = getSubscriptionBackendEndpoint();
      fetch(
        `${subscriptionEndpoint}/register-sub/free`,
        {
          method: "POST",
          body,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      ).then(trialRes => trialRes.json())
      .then(trialRes => {
        this.setState({
          loading: false
        });
        if (trialRes.status === 1) {
          const { location, history } = this.props
          if (location.pathname.split('/')[1] === 'web') {
            history.push("/web/?startConvo=true")
          } else if (location.pathname.split('/')[1] === 'scribe') {
            history.push("/scribe/")
          }
        } else if (trialRes.status === 0) {
          this.setState({
            loading: false,
            resError: 'newTrialError'
          })
        }
      })
    } else {
      this.setState({
        orgType
      })
    }
    const market = orgType === 'video' ? 'ind' : orgType;
    segment.track('Market Profiled', { Market: market });
    segment.identify({ Market: market });
  }

  setIsAdmin = (e) => {
    this.setState({
      isAdmin: e.target.value,
      isAdminRequiredError: false,
      resError: ''
    })
  }

  fetchOrganizationsByOrgName = async orgName => {
    const { firebaseUser } = this.props;
    const { orgType, currentlySearchingOrganizations } = this.state;
    if (!currentlySearchingOrganizations) return;
    const endpoint = getAvaBackendEndpoint();
    const request = await fetchWithToken(
      `${endpoint}/api/v1/find-organizations?keywords=${orgName}&firebaseAuthUID=${firebaseUser.uid}&orgType=${orgType}`
    );
    if (this.currentOrganizationSearch !== orgName) {
      // Because there is some delay, we may get answer from server
      // for something else than what is currently typed. We ignore it
      return;
    }
    const response = await request.json();
    // We keep 3 results, parse first
    const organizations =
      response.result &&
      response.result.resultFromParse &&
      response.result.resultFromParse.slice(0, 3).map(parseResult => ({
        name: parseResult.name,
        id: parseResult.objectId,
      }));
    if (organizations.length < 3) {
      const googleResults =
        response.result &&
        response.result.resultFromGoogle &&
        response.result.resultFromGoogle.results &&
        response.result.resultFromGoogle.results
          .slice(0, 3 - organizations.length)
          .map(googleResult => ({
            name: googleResult.name,
            address: googleResult.formatted_address,
            id: googleResult.place_id,
          }));
      organizations.push(...googleResults);
    }
    this.setState({
      organizationsSearchResults: organizations,
      showOrgSearchResults: true,
      currentlySearchingOrganizations: false,
    });
  };

  setOrgName = (e) => {
    this.setState({
      orgName: undefined,
      orgId: undefined,
      inputOrgName: e.target.value,
      orgNameRequiredError: false,
      resError: '',
    });
    if (e.target.value) {
      this.setState({
        currentlySearchingOrganizations: true
      });
      this.currentOrganizationSearch = e.target.value;
      if (this.findOrganizationsByOrgName) {
        this.findOrganizationsByOrgName(e.target.value);
      }
    } else {
      this.currentOrganizationSearch = null;
      this.setState({
        currentlySearchingOrganizations: false,
        organizationsSearchResults: null
      });
    }
  }

  submit = (e) => {
    e.preventDefault();
    const { isAdmin, orgName } = this.state
    if (!isAdmin || !orgName) {
      this.setState({
        isAdminRequiredError: !isAdmin,
        orgNameRequiredError: !orgName
      })
    } else {
      segment.track('Organization Profiled', { 'Organization Name': orgName });
      segment.track('Role Profiled', { 'Role': isAdmin === 'yes' ? 'admin' : 'user' });
      segment.identify({ 'Role': isAdmin === 'yes' ? 'admin' : 'user' });
      this.setState({
        resError: '',
        isAdminRequiredError: false,
        orgNameRequiredError: false,
        loading: true
      })
      const endpoint = getSaasBackendEndpoint();
      const { orgType, orgId } = this.state
      fetchWithToken(
        `${endpoint}/api/v1/organization/`,
        {
          method: 'POST',
          body: JSON.stringify({
            type: orgType,
            name: orgName,
            role: isAdmin === 'yes' ? 'admin' : 'user',
            placeId: orgId,
          }),
        }
      ).then(orgRes => orgRes.json())
      .then(orgRes => {
        if (orgRes.organization) {
          const parseAccount = window.localStorage.getItem("parseId")
          let type;

          switch (orgType) {
            case "hr":
              type = "Pro";
              break;
            case "edu":
              type = "Campus";
              break;
            case "worship":
              type = "Welcome";
              break;
            default:
              type = "Free";
              break;
          }

          const data = {
            parseAccount,
            "plateform": "Webapp",
            "subtype": "Trial",
            type,
          }

          const body = Object.keys(data).reduce((acc, cur) => `${acc}&${cur}=${data[cur]}`, '');

          const subscriptionEndpoint = getSubscriptionBackendEndpoint();
          fetch(
            `${subscriptionEndpoint}/register-sub/free`,
            {
              method: "POST",
              body,
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          ).then(trialRes => trialRes.json())
          .then(trialRes => {
            if (trialRes.status === 1) {
              const { userName } = this.state
              const { firebaseUser, i18n } = this.props
              const avaId = window.localStorage.getItem("avaId");
              const params = {
                chn: 'inb',
                src: 'onb',
                med: window.isElectron ? 'desk' : 'web',
                mkt: orgType,
                avaid: avaId,
                name: userName,
                orgname: orgName,
                role: isAdmin === 'yes' ? 'staff' : 'user',
                utm_campaign: window.utm_parameters && window.utm_parameters.name,
                ...(firebaseUser.email && { email: firebaseUser.email }),
                ...(firebaseUser.phoneNumber && { phone: firebaseUser.phoneNumber })
              }
              let baseUrl
              switch (i18n.language) {
                case 'fr':
                  baseUrl = 'https://ava-me.typeform.com/to/R8L5rC';
                  break;
                case 'en':
                default:
                  baseUrl = 'https://ava-me.typeform.com/to/q2n11h';
                  break;
              }
              const url = `${baseUrl}${Object.keys(params).reduce((acc, cur) => `${acc}&${cur}=${params[cur]}`, '?')}`
              if (window.isElectron) {
                const { shell } = window.require('electron')
                shell.openExternal(url)
                window.location.href = '/'
              } else {
                window.location.href = url
              }
            } else if (trialRes.status === 0) {
              this.setState({
                loading: false,
                resError: 'newTrialError'
              })
            }
          })
        } else if (
          orgRes.error &&
          orgRes.error.error &&
          orgRes.error.error.content &&
          orgRes.error.error.content.errorCode === 'adminAlreadyExists'
        ) {
          this.setState({
            loading: false,
            resError: 'adminAlreadyExists'
          })
        } else {
          this.setState({
            loading: false,
            resError: 'unexpected'
          })
        }
      })
    }
  }

  render() {
    const { classes, t } = this.props;
    const {
      userNameRequiredError,
      userNameResError,
      isAdmin,
      isAdminRequiredError,
      orgName,
      orgId,
      orgNameRequiredError,
      orgType,
      inputOrgName,
      resError,
      loading,
      organizationsSearchResults,
      showOrgSearchResults,
      currentlySearchingOrganizations,
    } = this.state;

    let organizationSearchResultPicto;
    switch (orgType) {
      case 'edu':
        organizationSearchResultPicto = eduOrg;
        break;
      case 'event':
        organizationSearchResultPicto = eventOrg;
        break;
      default:
        organizationSearchResultPicto = hrOrg;
        break;
    }

    return (
      <div className={classes.outerWrap}>
        <Route
          path={[
            "/web/login/profile/user-name",
            "/scribe/login/profile/user-name",
            "/web/login/profile/user-name-subscribed",
            "/scribe/login/profile/user-name-subscribed"
          ]}
          render={() => {
            return (
              <div>
                <form className={classes.orgInfoOptionsWrap}>
                  <Typography
                    variant="h4"
                    align="center"
                    className={classes.title}
                    gutterBottom
                  >
                    {t('profiling.userName.heading')}
                  </Typography>
                  <Typography
                    variant="body1"
                    align="center"
                    gutterBottom
                  >
                    {t(`profiling.userName.body`)}
                  </Typography>
                  <FormControl
                    className={classes.formControl}
                    component="fieldset"
                    margin="normal"
                  >
                    <TextField
                      required
                      fullWidth
                      onChange={(e) => this.setUserName(e)}
                      label={t("profiling.userName.label")}
                      variant="outlined"
                      error={userNameRequiredError}
                    />
                    {userNameRequiredError && (
                      <FormHelperText error className={classes.helperText}>
                        {t('profiling.userName.required')}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={() => this.submitUserName()}
                    disabled={this.disabledUsername() || !!loading}
                  >
                    {loading && <CircularProgress size={20} color="secondary" />}
                    {!loading && t('profiling.userName.continue')}
                  </Button>
                  {userNameResError && (
                    <FormHelperText error className={classes.centerText}>
                      {t(`profiling.userName.resError`)}
                    </FormHelperText>
                  )}
                </form>
              </div>
            )
          }}
        />
        <Route
          path={["/web/login/profile/hearing-profile", "/scribe/login/profile/hearing-profile"]}
          render={() => {
            return (
              <div>
                <Typography
                  variant="h4"
                  align="center"
                  className={classes.title}
                  gutterBottom
                >
                  {t("profiling.hearingProfile.heading")}
                </Typography>
                <Typography
                  variant="body1"
                  align="center"
                  gutterBottom
                >
                  {t("profiling.hearingProfile.body")}
                </Typography>
                <div className={classes.fabContainer}>
                  <Fab variant="extended" className={classes.fab} onClick={() => this.setHearingProfile('deaf')}>
                    <div style={{flexGrow: 1}}>
                      <span>
                        {t('profiling.hearingProfile.deaf.0')}&nbsp;
                      </span>
                      <span className={classes.fabBold}>
                        {t('profiling.hearingProfile.deaf.1')}&nbsp;
                      </span>
                      <span>
                        {t('profiling.hearingProfile.deaf.2')}<br />
                      </span>
                      <span className={classes.fabBold}>
                        {t('profiling.hearingProfile.deaf.3')}
                      </span>
                    </div>
                    <div>
                      <img src={DeafEmoji} alt="deaf" />
                    </div>
                  </Fab>
                  <Fab variant="extended" className={classes.fab} onClick={() => this.setHearingProfile('hard-of-hearing')}>
                    <div style={{flexGrow: 1}}>
                      <span>
                        {t('profiling.hearingProfile.hoh.0')}&nbsp;
                      </span>
                      <span className={classes.fabBold}>
                        {t('profiling.hearingProfile.hoh.1')}&nbsp;
                      </span>
                      <span>
                        {t('profiling.hearingProfile.hoh.2')}<br />
                      </span>
                      <span className={classes.fabBold}>
                        {t('profiling.hearingProfile.hoh.3')}
                      </span>
                    </div>
                    <div>
                      <img src={HohEmoji} alt="hard of hearing" />
                    </div>
                  </Fab>
                  <Fab variant="extended" className={classes.fab} onClick={() => this.setHearingProfile('hearing')}>
                    <div style={{flexGrow: 1}}>
                      <span>
                        {t('profiling.hearingProfile.hearing.0')}&nbsp;
                      </span>
                      <span className={classes.fabBold}>
                        {t('profiling.hearingProfile.hearing.1')}&nbsp;
                      </span>
                      <span>
                        {t('profiling.hearingProfile.hearing.2')}<br />
                      </span>
                      <span className={classes.fabBold}>
                        {t('profiling.hearingProfile.hearing.3')}
                      </span>
                    </div>
                    <div>
                      <img src={EarEmoji} alt="ear" />
                    </div>
                  </Fab>
                </div>
              </div>
            )
          }}
          />
        <Route
          path={["/web/login/profile/voicing-profile", "/scribe/login/profile/voicing-profile"]}
          render={() => {
            return (
              <div>
                <Typography
                  variant="h4"
                  align="center"
                  className={classes.title}
                  gutterBottom
                >
                  {t("profiling.voicingProfile.heading")}
                </Typography>
                <Typography
                  variant="body1"
                  align="center"
                  gutterBottom
                >
                  {t("profiling.voicingProfile.body")}
                </Typography>
                <img src={SomeoneSpeaking} alt="someone speaking" style={{maxWidth: 300, margin: 'auto', display: 'block'}} />
                <div className={classes.fabContainerVoicingProfile}>
                  <Fab variant="extended" className={[classes.fab, classes.fabMargin]} onClick={() => this.setVoicingProfile('voicing')}>
                    <span className={classes.fabBold}>
                      {t('profiling.voicingProfile.yes')}
                    </span>
                  </Fab>
                  <Fab variant="extended" className={[classes.fab, classes.fabMargin]} onClick={() => this.setVoicingProfile('not voicing')}>
                    <span className={classes.fabBold}>
                      {t('profiling.voicingProfile.notAlways')}
                    </span>
                  </Fab>
                </div>
              </div>
            )
          }}
          />
        <Route
          path={["/web/login/profile/org-type", "/scribe/login/profile/org-type"]}
          render={() => {
            if (loading) {
              return <Loading text={t('loading3d')} />;
            }
            return (
              <div>
                <Typography
                  variant="h4"
                  align="center"
                  className={classes.title}
                  gutterBottom
                >
                  {t("profiling.orgType.heading")}
                </Typography>
                <Typography
                  variant="body1"
                  align="center"
                  gutterBottom
                >
                  {t("profiling.orgType.body")}
                </Typography>
                <div className={classes.orgTypeOptionsWrap}>
                  <Link
                    to="org-info"
                    type="button"
                    className={classes.orgTypeButton}
                    onClick={() => this.setOrgType('hr')}
                    style={{color: 'rgb(75, 75, 75'}}
                  >
                    <Typography
                      variant="h6"
                      align="center"
                      className={classes.title}
                      gutterBottom
                    >
                      {t("profiling.orgType.work")}
                    </Typography>
                    <img
                      src={Work}
                      alt="Laptop with Ava captioning on screen"
                      className={classes.orgTypeIllustration}
                    />
                  </Link>
                  <Link
                    to="org-info"
                    type="button"
                    className={classes.orgTypeButton}
                    onClick={() => this.setOrgType('edu')}
                    style={{color: 'rgb(75, 75, 75'}}
                  >
                    <Typography
                      variant="h6"
                      align="center"
                      className={classes.title}
                      gutterBottom
                    >
                      {t("profiling.orgType.school")}
                    </Typography>
                    <img
                      src={School}
                      alt="Laptop with Ava captioning on screen"
                      className={classes.orgTypeIllustration}
                    />
                  </Link>
                  <Link
                    to="org-info"
                    type="button"
                    className={classes.orgTypeButton}
                    onClick={() => this.setOrgType('event')}
                    style={{color: 'rgb(75, 75, 75'}}
                  >
                    <Typography
                      variant="h6"
                      align="center"
                      className={classes.title}
                      gutterBottom
                    >
                      {t("profiling.orgType.event")}
                    </Typography>
                    <img
                      src={Event}
                      alt="Laptop with Ava captioning on screen"
                      className={classes.orgTypeIllustration}
                    />
                  </Link>
                  <button
                    type="button"
                    className={classes.orgTypeButton}
                    onClick={() => this.setOrgType('video')}
                    style={{color: 'rgb(75, 75, 75'}}
                  >
                    <Typography
                      variant="h6"
                      align="center"
                      className={classes.title}
                      gutterBottom
                    >
                      {t("profiling.orgType.video")}
                    </Typography>
                    <img
                      src={Video}
                      alt="Laptop with Ava captioning on screen"
                      className={classes.orgTypeIllustration}
                    />
                  </button>
                </div>
              </div>
            )
          }}
          />
        <Route
          path={["/web/login/profile/org-info", "/scribe/login/profile/org-info"]}
          render={() => {
            return (
              <div>
                <form className={classes.orgInfoOptionsWrap}>
                  <Typography
                    variant="h4"
                    align="center"
                    className={classes.title}
                    gutterBottom
                  >
                    {t(`profiling.orgInfo.heading.${orgType}`)}
                  </Typography>
                  <Typography
                    variant="body1"
                    align="center"
                    gutterBottom
                  >
                    {t(`profiling.orgInfo.body`)}
                  </Typography>
                  <FormControl
                    className={classes.formControl}
                    component="fieldset"
                    margin="normal"
                  >
                    <div style={{position: 'relative'}}>
                      <TextField
                        required
                        fullWidth
                        value={orgName || inputOrgName}
                        onChange={e => this.setOrgName(e)}
                        label={t(`profiling.orgInfo.orgName.label.${orgType}`)}
                        variant="outlined"
                        error={resError === 'adminAlreadyExists'}
                        InputProps={{
                          className: orgName && classes.searchFieldWithPadding,
                        }}
                        onFocus={() => {
                          if (inputOrgName && organizationsSearchResults && !showOrgSearchResults) {
                            setTimeout(() => {
                              this.setState({ showOrgSearchResults: true });
                            }, 50);
                          }
                        }}
                      />
                      {orgName && (
                        <img
                          className={classes.searchResultTypePicto}
                          alt="search result picto"
                          src={orgId ? organizationSearchResultPicto : addOrg}
                        />
                      )}
                      {currentlySearchingOrganizations && (
                        <CircularProgress
                          size={20}
                          className={classes.orgaSearchProgress}
                        />
                      )}
                      {showOrgSearchResults && (
                        <OrganizationsSearchResults
                          searchResults={organizationsSearchResults}
                          query={inputOrgName}
                          onSelectResult={result => {
                            this.setState({
                              orgName: result.name,
                              orgId: result.id,
                              showOrgSearchResults: false,
                            });
                          }}
                          orgType={orgType}
                          onClickOutside={() =>
                            this.setState({ showOrgSearchResults: false })
                          }
                        />
                      )}
                    </div>
                    {orgNameRequiredError && (
                      <FormHelperText error className={classes.helperText}>
                        {t('profiling.orgInfo.required')}
                      </FormHelperText>
                    )}
                    {resError === 'adminAlreadyExists' && (
                      <FormHelperText error className={classes.helperText}>
                        {t('profiling.orgInfo.res.adminAlreadyExists')}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <FormControl
                    component="fieldset"
                    margin="none"
                    required
                  >
                    <FormLabel component="legend" className={classes.formLabel}>
                      {t(`profiling.orgInfo.isAdmin.${orgType}`)}
                    </FormLabel>
                    <RadioGroup value={isAdmin} onChange={(e) => this.setIsAdmin(e)} row>
                      <FormControlLabel value="yes" control={<Radio />} label={t('profiling.orgInfo.isAdmin.yes')} />
                      <FormControlLabel value="no" control={<Radio />} label={t('profiling.orgInfo.isAdmin.no')} />
                      {isAdminRequiredError && (
                        <FormHelperText error className={classes.checkboxHelperText}>
                          {t('profiling.orgInfo.required')}
                        </FormHelperText>
                      )}
                    </RadioGroup>
                  </FormControl>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={(e) => this.submit(e)}
                    disabled={!orgName}
                  >
                    {loading && <CircularProgress size={20} color="secondary" />}
                    {!loading && t('profiling.orgInfo.continue')}
                  </Button>
                  {resError === 'newTrialError' && (
                    <FormHelperText error className={classes.centerText}>
                      {t(`profiling.orgInfo.res.newTrialError`)}
                    </FormHelperText>
                  )}
                  {resError === 'unexpected' && (
                    <FormHelperText error className={classes.centerText}>
                      {t(`profiling.orgInfo.res.unexpectedError`)}
                    </FormHelperText>
                  )}
                </form>
              </div>
            )
          }}
        />
      </div>
    )
  }
}
export default withTranslation()(withStyles(styles)(withRouter(ScribeLoginProfiling)));
